import API_ROOT from "./../constants/urlAPI";
import API_MAILER from "./../constants/sendUrl";
export const GET = (...args) => makeRequest("GET", ...args);
export const POST = (...args) => makeRequest("POST", ...args);
export const PUT = (...args) => makeRequest("PUT", ...args);
export const DELETE = (...args) => makeRequest("DELETE", ...args);

const formData = (object) =>
  Object.keys(object).reduce((form, key) => {
    form.append(key, object[key]);
    return form;
  }, new FormData());

async function makeRequest(
  method,
  endpoint,
  rawData = false,
  multipart = false,
  sendEmulation = true,
  mailer = false
) {
  const headers = new Headers({
    "Content-Type": "application/json",
  });
  const options = {
    method,
    headers,
    mode: "cors",
    cache: "default",
  };
  const body =
    !!rawData && (multipart ? formData(rawData) : JSON.stringify(rawData));

  if (!!body) {
    Object.assign(options, { body });
  }
  const request = new Request(
    (mailer ? API_MAILER : API_ROOT) + endpoint,
    options
  );
  try {
    const data = await fetch(request);
    const json = await data.json();
    if (json) return json;
  } catch ({ message, name, number, url }) {
    // getError({ message, name, number, url });
  }
}

export async function postJson(url, body) {
  const options = {
    method: "POST",
    headers: new Headers({ "Content-Type": "application/json" }),
    mode: "cors",
    cache: "default",
    body: JSON.stringify(body),
  };
  try {
    const response = await fetch(new Request(url, options));
    return await response.json();
  } catch ({ message, name, number, url }) {
    // getError({ message, name, number, url });
  }
}

const makeToQuery = (query, noGet = false) => {
  if (!query) return "";
  var str = [];
  for (let p in query)
    if (query.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(query[p]));
    }
  if (noGet) return str.join("&");
  return "?" + str.join("&");
};

export const ApiConnector = (prefix = "") => {
  return (
    callback,
    endpoint,
    multipart = false,
    query = false,
    sendEmulation = true,
    mailer = false
  ) => ({
    async call(body = false, skipGlobalErrorStack = false) {
      try {
        return await callback(
          ...[
            prefix + endpoint + makeToQuery(query),
            body,
            multipart,
            sendEmulation,
            mailer,
          ]
        );
      } catch (message) {}
    },
  });
};
